import { styled } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";

const StyledInputLabel = styled(InputLabel, {
})(({ theme }) => ({
  "&.MuiInputLabel-root": {
    color: theme.palette["black_solid"]["70"],
    left: "-6px",
    fontSize: theme.typography["body1"]["fontSize"],
    marginTop: "-12px",
    "&.Mui-focused": {
      color: theme.palette["primary"]["60"],
    },
    "&.Mui-error": {
      color: theme.palette["error"]["60"],
    },
    "&.Mui-disabled": {
      color: theme.palette["black_opacity"]["70"],
    }
  },
  "&.MuiInputLabel-shrink": {
    marginTop: "0px"
  }
})); 

export default StyledInputLabel;